import React, { useState, useRef, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { useGoogleLogin } from "@react-oauth/google";
import axios from "axios";
import { IMAGE_PATHS } from "../Functions/Constant";
import { useNavigate } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import ReCAPTCHA from "react-google-recaptcha";
import API from '../Api/Api';
import { API_BASE_URL } from '../Functions/Constant';
import Home from "./Home";

const CustomModal = ({ show, handleClose, setShowEmailModal, isRecaptchaVerified, handleRecaptchaChange }) => {
  const navigate = useNavigate();

  const handleModalClose = () => {
    handleClose();
    navigate("/");
  };
  const handleEmail = () => {
    handleClose();
    setShowEmailModal(true)
  };

  const handleGoogleLogin = () => {
    window.location.href = API_BASE_URL + "/auth/google";
  };

  return (
    <Modal show={show} onHide={handleModalClose} centered backdrop="static" keyboard={false}>
    <Modal.Header closeButton>
      <Modal.Title className="text-center w-100">
        <img src={IMAGE_PATHS.LOGO} alt="Logo" className="logo-cls" width="50" />
      </Modal.Title>
    </Modal.Header>
    <Modal.Body className="text-center p-[50px]">
      <h4 className="font-bold text-gray-900">Sign In to JobCritics to Build Your Professional Reputation.</h4>

      <Row className="flex justify-center">
        <Col lg={12} md={12} className="flex justify-center">
          {/* Google Sign-in Button */}
          <Button className="btn-explore-white-glogin flr-d flex items-center j-sa" onClick={handleGoogleLogin}  >
            <img src={IMAGE_PATHS.GOOGLE} alt="Google" className="icon-social w-[8%] " />
            Continue with Google
          </Button>
        </Col>
      </Row>
      <Row className="flex justify-center">
        <Col lg={6} md={12} className="flex justify-center">

          <Button className="btn-explore-white my-3 flr-d flex items-center j-sa !pr-[36px] !pl-[23px]" onClick={handleEmail} >
            <i className="solid-icon-Email mr-[14px] text-[13px]"></i>
            Continue with Email
          </Button>

        </Col>
      </Row>
      <p className="text-sm text-gray-600 mt-3">
        By proceeding, you agree to our <a href="/term_policy" className="yellow-class hover:underline hover:underline decoration-black">Terms of Use </a>
        and confirm you have read our <a href="/privacy" className="yellow-class hover:underline hover:underline decoration-black">Privacy and Cookie Statement</a>.
      </p>
    </Modal.Body>
  </Modal>
    
  );
};

const SuccessModal = ({ show, handleClose, setShowEmailModal, email }) => { // Added email prop
  const navigate = useNavigate();
  const [resendMessage, setResendMessage] = useState("");

  const handleClose2 = () => {
    navigate("/");
    handleClose();
  };

  const handleResend = async () => {
    try {
      const payload = { email };
      const response = await API.post("/loginEmail/login", payload);
      setResendMessage("Link sent successfully!");
    } catch (error) {
      console.error("API Error:", error);
      setResendMessage("Failed to resend. Please try again.");

    }
  };

  const handleGoBack = () => {
    setShowEmailModal(true);
    handleClose();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose2}
      dialogClassName="custom-modal-dialog"
      centered
      backdrop="static" keyboard={false}
    >
      <Modal.Body className="pt-[12px] pb-[15px]">
        <p className="text-gray-600 text-center flex items-center justify-center  p-[1px]">
          <img
            src="https://jobcritics.com/assets/img/biar/magiclink.webp"
            alt="Success!"
            className="w-[150px] mr-2"
          />
        </p>
        <h6 className="font-semibold text-black text-center w-full mb-0 mt-[0px] pb-[5px]">Success!</h6>
        <p className="text-gray-600 text-center text-[17px] leading-[1.6] pb-[0px]">
          We’ve sent a secure login link to <strong className="text-blue-600 hover:underline cursor-pointer">{email}</strong>.
        </p>
        <p className="text-gray-600 text-center text-[17px] leading-[1.6] pb-[15px]">
          Click the link in your email to sign in.
        </p>
        <div className="mt-2 text-gray-600">
          <p className="text-gray-600 text-center text-[17px] leading-[1.6] pb-[0px]"><strong>Didn’t get the email?</strong></p>
          <ul className="list-none pl-0">
            <li className="text-gray-600 text-center text-[17px] leading-[1.6] pb-[15px]">
              Check your spam or promotions folder
            </li>
          </ul>
        </div>
        <div className="grid mt-[11px] w-full gap-3 w-full justify-center">
          <button
            className="btn-explore-yellow text-c pd3 !w-[294px]"
            onClick={handleResend}
          >
            Resend link
          </button>
          <p
            className="text-gray-700  hover:text-base hover:bg-gray-200 hover:rounded-[24px] cursor-pointer text-center text-c !p-[8px] !w-[300px] "
            onClick={handleGoBack}
          >
           GO BACK
          </p>
        </div>
         {resendMessage && (
          <p className="text-center mt-2 text-sm text-green-500">
            {resendMessage}
          </p>
        )}
      </Modal.Body>

    </Modal>
  );
};

const LoginForm = () => {
  const [showModal, setShowModal] = useState(false);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false); // Success modal state
  const [isRecaptchaVerified, setIsRecaptchaVerified] = useState(false);
  const recaptchaRef = useRef();
  const [submittedEmail, setSubmittedEmail] = useState("");
  const navigate = useNavigate();

  // Check localStorage for userData on component mount
  useEffect(() => {
    // const userData = localStorage.getItem("userData");
    // if (userData) {
    //   //navigate("/profile"); // Navigate to profile if userData exists
    // }
  }, [navigate]);
  useEffect(() => {
    const userData = localStorage.getItem("userData");
    if (userData) {
      // navigate("/profile"); // Navigate to profile if userData exists
    }else{
      setShowModal(true); // Show the modal if userData does not exist
    }
    const loadRecaptchaScript = () => {
      const script = document.createElement("script");
      script.src = "https://www.google.com/recaptcha/api.js?render=explicit";
      script.async = true;
      document.body.appendChild(script);
    };
    loadRecaptchaScript();
    
  }, []);
  const handleRecaptchaChange = (value) => {
    setIsRecaptchaVerified(!!value);
  };

  const EmailSchema = Yup.object().shape({
    email: Yup.string().email("Invalid email").required("Email is required"),
    recaptcha: Yup.bool().oneOf([true], "Please verify the reCAPTCHA").required("reCAPTCHA is required"),
  });
  const handleSuccessModalClose = () => setShowSuccessModal(false);


  return (
    <div>
      <Home />
      <CustomModal show={showModal} handleClose={() => setShowModal(false)} setShowEmailModal={setShowEmailModal} isRecaptchaVerified={isRecaptchaVerified}
        handleRecaptchaChange={handleRecaptchaChange} />
      <Modal
        show={showEmailModal}
        onHide={() => {
          setShowEmailModal(false);
          setShowModal(true);
          setIsRecaptchaVerified(false);
          recaptchaRef.current?.reset();
        }}
        centered
        backdrop="static" keyboard={false}
        dialogClassName="custom-modal-dialog"
      >

        <Modal.Body className="pt-[18px] pb-[14px]">
          <p className="text-gray-600 text-center flex items-center justify-center  p-[1px]">
            <img
              src="https://jobcritics.com/assets/img/biar/emailnew.webp"
              alt="Sign in with Magic Link"
              className="w-[150px] mr-2"
            />
          </p>
          <h6 className="font-semibold text-black text-center w-full mb-0 mt-[4px] pb-[5px]">Sign in with Magic Link</h6>
          <p className="text-gray-600 text-center text-[17px] leading-[1.6] pb-[15px]">
            Enter your email address and we’ll send you a secure login link.
          </p>

          <Formik
            initialValues={{ email: "", recaptcha: false }}
            validationSchema={EmailSchema}
            onSubmit={async (values, { resetForm }) => {
              if (!isRecaptchaVerified) return;
              try {
                const payload = { email: values.email };
                const response = await API.post("/loginEmail/login", payload);
                setSubmittedEmail(values.email);
                setShowSuccessModal(true);

                resetForm();
                setShowEmailModal(false);
              } catch (error) {
                console.error("API Error:", error);
              }
            }}
          >
            {({ isSubmitting, setFieldValue }) => (
              <Form>
                <div className="mb-1">
                  <Field
                    name="email"
                    type="email"
                    placeholder="Your email address"
                    className="form-control fomc-cls"
                  />
                  <ErrorMessage name="email" component="div" className="text-danger text-sm mt-0" />
                </div>
                <div className=" mb-[20px] mt-[10px]">
                  <ReCAPTCHA
                    ref={recaptchaRef}
                    sitekey="6LeMeB0rAAAAANu99dAvFdegQ5rV6L-8plZSr4Fa"
                    onChange={(value) => {
                      handleRecaptchaChange(value);
                      setFieldValue("recaptcha", !!value);
                    }}
                    className="mt-4 flex justify-center"
                  />
                   <ErrorMessage name="recaptcha" component="div" className="text-danger text-sm mt-0 text-center" />
                </div>
               

               


                <div className="grid mt-[16px] w-full gap-3 w-full justify-center">
                  <Button
                    className="btn-explore-yellow text-c pd3 !w-[294px]"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    Send Magic Link
                  </Button>
                  <p
                    className="text-gray-700  hover:text-base hover:bg-gray-200 hover:rounded-[24px] cursor-pointer text-center text-c !p-[8px] !w-[300px] "
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowEmailModal(false);
                      setShowModal(true);
                      setIsRecaptchaVerified(false);
                      recaptchaRef.current?.reset();
                    }}
                  >
                    GO BACK
                  </p>
                </div>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
      <SuccessModal show={showSuccessModal} handleClose={handleSuccessModalClose} setShowEmailModal={setShowEmailModal} email={submittedEmail} />

    </div>
  );
};

export default LoginForm;
